import { Tag } from '@/shared/ui/tag/Tag';
import type { SelectOption } from '../helpers/types';
import { normalizeOptionValue } from '../helpers/utils';

type MultipleSelectTriggerContentProps = {
  selectedOptions: SelectOption[];
  placeholder: string;
  toggleValue: (optionValue: string | number) => void;
};

export const MultipleSelectTriggerContent = ({
  selectedOptions,
  placeholder,
  toggleValue,
}: MultipleSelectTriggerContentProps) => {
  if (selectedOptions.length === 0) {
    return <span className="truncate text-text-muted">{placeholder}</span>;
  }

  return (
    <div className="flex flex-1 flex-wrap items-center gap-1">
      {selectedOptions.map((option) => (
        <Tag key={normalizeOptionValue(option.value)} onRemove={() => toggleValue(option.value)}>
          {option.label}
        </Tag>
      ))}
    </div>
  );
};
